module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tocchaptitle"
  }, [_c('a', {
    attrs: {
      "id": "loi"
    }
  }), _vm._v("List of Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/07_chapter01#fig1"
    }
  }, [_vm._v("1. Cliffside cave, Chicken Foot Mountain, China")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/10_chapter04#fig2"
    }
  }, [_vm._v("2. White skeleton visualization method")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter06#fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Zhunti Buddha")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter07#fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Vairocana Buddha")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter10#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The nine-bottled winds exercise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter11#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Kundalini yoga")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter14#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Thousand-year-old Chinese recipe for siddhi medicine")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-037d1897","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_list-of-illustrations.vue
// module id = 69
// module chunks = 0